import FullscreenCollapse from "assets/icons/FullscreenCollapse.svg?react";
import FullscreenExpand from "assets/icons/FullscreenExpand.svg?react";

import styles from "./DocumentResults.module.scss";

export const ExpandControls = (props: {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}) => {
  const { expanded, setExpanded } = props;
  const handleClick = () => {
    setExpanded(!expanded);
  };
  return (
    <div
      onClick={handleClick}
      className={styles.icon}
    >
      {expanded ? <FullscreenCollapse /> : <FullscreenExpand />}
    </div>
  );
};
